import React, { Component } from "react";
import { Icon, Input, AutoComplete } from "antd";
import axios from "axios";

import "./styles.css";

// import CatNames from "./CatNames";
// const dataSource = CatNames;
// console.log("original:", dataSource);

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      value: "",
    };
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  onChange = (value) => {
    this.setState({ value: value });
    // if (
    //   this.state.dataSource.some(el => {
    //     return el === value;
    //   })
    // ) {
    //   this.setState({ value: "" });
    // }
  };

  onSelect = (value) => {
    // console.log("onSelect", value);

    // someFn = () => {
    //   const catSelected = value;
    this.props.callbackFromParent(value);
    // this.setState({ value: "test" }, function() {
    //   console.log("clearstateonselect: ", this.state.value);
    // });
    // };
  };

  componentDidMount() {
    // fetch(
    //   "https://24e1621c-771a-4118-ba27-f508d48c84c2.mock.pstmn.io/api/catnames"
    // ).then(results => {
    //   console.log(results, typeof results.catNames);

    //   let dataSource = results.catNames;
    //   this.setState({ dataSource: dataSource }, function() {
    //     console.log(this.state.dataSource);
    //   });
    // });

    axios
      .get("https://onestoppress.com/api/catnames")

      // "https://24e1621c-771a-4118-ba27-f508d48c84c2.mock.pstmn.io/api/catnames"

      // .then(res => {
      //   return res.json();
      // })
      .then((res) => {
        // let res = JSON.parse(dataa);
        // console.log("new: ", typeof dataa.data.catnames, dataa.data.catnames);
        let dataSource = res.data.catnames;
        this.setState({ dataSource: dataSource }, function () {
          // console.log("state: ", this.state.dataSource);
        });
      })
      .catch((err) => console.log("err: ", err));
  }

  render() {
    return (
      <div>
        <AutoComplete
          allowClear={true}
          value={this.state.value}
          backfill={true}
          style={{ float: "right", display: "block" }}
          dataSource={this.state.dataSource}
          placeholder="Search to add cats"
          filterOption={(inputValue, option) =>
            option.props.children
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          className="searchbar"
          onSelect={this.onSelect}
          // onChange={this.debounce(this.onChange, 100)}
          onChange={this.onChange}
        >
          <Input
            suffix={<Icon type="search" className="certain-category-icon" />}
            style={{
              opacity: "1",
            }}
          />
        </AutoComplete>
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/autocomplete/SearchBar.js